/**
 * "Contact School" / "Contact Partner" — the mailto the button links to.
 *
 * The button is a native mailto link: the browser opens the user's email app
 * on the click itself. It must be the link, not script — Chrome allows one
 * external launch per user click, and a mailto set from code was dropped with
 * "Not allowed to launch 'mailto:…' because a user gesture is required".
 *
 * @returns {string} the mailto, or '' when there is no address
 */
export const contactMailtoHref = (to, subject = '') =>
    (to ? `mailto:${to}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}` : '');
